<template>
	<div>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Pengiriman Retur</div>
		</div>
		<div v-if="loading">
			<loading-card-supplier></loading-card-supplier>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="grey lighten-3" class="pa-3">
					<v-list-item dense class="px-1">
						<div>
							<v-tabs color="cyan darken-2" background-color="grey lighten-3" class="change-display" height="40">
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="cyan darken-2 white--text mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="cyan darken-2 white--text" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="2" >
								<v-text-field outlined dense hide-details label="Kode Pengiriman" v-model="pdor_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="4" >
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalRetur)" label="Tanggal Pengiriman" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hint="Bisa pilih range tanggal"></v-text-field>
									</template>
									<v-date-picker locale="id" first-day-of-week="0" range color="cyan darken-2" v-model="tanggalRetur" :max="today"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete item-text="status" item-value="code" outlined dense hide-details v-model="pdor_status.value" :items="optionStatus" label="Status" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
						</v-row>
					</v-col>
					<v-card-actions class="px-4">
						<v-spacer></v-spacer>
						<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
						<v-btn depressed color="cyan darken-2" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
					</v-card-actions>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-show="!cardDisplay">
				<v-data-table dense loading :headers="headers" :items="listRD" hide-default-footer :options.sync="option" :server-items-length="RDPagination.total_data" disable-pagination>
					<template v-slot:item.created_datetime="{ item }">
						<div class="pt-2">{{ item.pdor_status_created_datetime | tanggalid }}</div>
						<div class="pt-3 pb-3">
							<v-btn x-small dense text color="grey darken-1" class="pl-0"><v-icon>mdi-printer</v-icon></v-btn>
							<v-btn x-small text color="cyan darken-2" dark class="pl-0"><v-icon>mdi-file-document-outline</v-icon></v-btn>
							<v-btn x-small dense text color="grey darken-1" class="pl-0"><v-icon>mdi-format-list-bulleted-square</v-icon></v-btn>
						</div>
					</template>
					<template v-slot:item.pdor_code="{ item }">
						<div>{{ item.pdor_code }}</div>
					</template>
					<template v-slot:item.pdor_note="{ item }">
						<div>{{ item.pdor_note ? item.pdor_note : '-' }}</div>
					</template>
					<template v-slot:item.supplier="{ item }">
						<div class="py-2">
							<div>{{ item.warehouse_name }}</div>
							<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.warehouse_mobilephone }}</span></div>
							<div class="pt-1"><v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ item.warehouse_address }}</span></div>
						</div>
					</template>
					<template v-slot:item.status="{ item }">
						<div class="pt-2 text-capitalize">{{ item.pdor_status | toStatusPDOWH }}</div>
						<div class="pt-2 pb-2">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mr-1" fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on" @click.stop="getDetail(item.pdor_code)">
										<v-icon dark>mdi-text-box-search</v-icon>
									</v-btn>
								</template>
								<span>Detail</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!RDPagination">
							<loading-data-cyan></loading-data-cyan>
						</div>
						<div class="py-3" v-else>
							<not-found-cyan></not-found-cyan>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div v-show="cardDisplay">
				<v-card outlined v-if="listRD.length == 0 && RDPagination">
					<div class="py-3">
						<not-found-cyan></not-found-cyan>
					</div>
				</v-card>
				<v-card v-else class="mb-3" outlined v-for="delivery in listRD" :key="delivery.pdor_id">
					<v-list color="grey lighten-3" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Retur {{ delivery.pdor_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn small text depressed class="cyan darken-2 white--text"  @click="printRD(delivery.pdor_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Warehouse</div>
									<div class="subtitle-2">{{ delivery.warehouse_name }}</div>
									<div class="body-2 pt-3">
										<v-icon small>mdi-phone</v-icon><span class="pl-2">{{ delivery.warehouse_mobilephone }}</span>
									</div>
									<div class="body-2 pt-1">
										<v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ delivery.warehouse_address }}</span>
									</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Tanggal Retur</div>
									<div class="subtitle-2">{{ delivery.pdor_status_created_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3 class="pr-3">
									<div class="body-2 oppacity-75">Catatan</div>
									<div class="subtitle-2 text-capitalize">{{ delivery.pdor_note ? delivery.pdor_note : '-' }}</div>
								</v-flex>
								<v-flex xs6 sm2 md2>
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ delivery.pdor_status | toStatusPDOWH }}</div>
								</v-flex>
								<v-flex xs6 sm1 md1 text-right>
									<div>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on" @click.stop="getDetail(delivery.pdor_code)">
													<v-icon dark>mdi-text-box-search</v-icon>
												</v-btn>
											</template>
											<span>Detail</span>
										</v-tooltip>
									</div>
								</v-flex>
							</v-layout>
							<div class="pt-3">
								<v-card outlined>
									<v-data-table dense :headers="headersProduct" :items="delivery.pdor_detail" :items-per-page="1000" class="elevation-0" hide-default-footer>
										<template v-slot:item.pdor_detail_product_price="{ item }">
											<div>{{ item.pdor_detail_product_price | toNumber }}</div>
										</template>
										<template v-slot:item.pdor_detail_quantity_sent="{ item }">
												{{ item.pdor_detail_quantity_sent | toNumber }}
										</template>
										<template v-slot:item.pdor_detail_quantity_received="{ item }">
											<div>{{ item.pdor_detail_quantity_received | toNumber }}</div>
										</template>
									</v-data-table>
									<!-- <div class="d-flex justify-end py-2">
										<div class="font-weight-bold text-right px-4">Total Pembayaran</div>
										<div class="font-weight-bold text-right px-4">{{ countGrandtotal(delivery.pdor_detail, delivery.pdor_status) | toRupiah }}</div>
									</div> -->
								</v-card>
							</div>
						</v-list-item-content>
					</v-list-item>
				</v-card>
			</div>
			<div class="pt-5">
				<v-row>
					<v-col cols="10" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-if="RDPagination.total_page > 1 && listRD.length > 0" @input="changePage" v-model="page" :length="RDPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="2" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'
import modalDetail from '@/views/MLsupplier/retur/DetailReturDelivery'
import modalPrint from '@/views/MLsupplier/retur/PrintReturDelivery'

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: true,
			menu: false,
			loading: true,
			tanggalRetur: [],
			pdor_code: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'pdor_code'
			},
			pdor_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'pdor_status_created_datetime'
			},
			pdor_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'pdor_status'
			},
			sortBy: 'pdor_id',
			sortDir: 'DESC',
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			dialog: false,
			dialogPrint: false,
			dialogConfirm: false,
			headers: [
			{ text: 'Tanggal Retur', value: 'created_datetime' },
			{ text: 'Kode Retur', sortable: true, value: 'pdor_code'},
			{ text: 'Warehouse', value: 'supplier', width:"40%"},
			{ text: 'Catatan', value: 'pdor_note' },
			{ text: 'Status', value: 'status' },
			],
			headersProduct: [
			{ text: 'Nama Produk', value: 'supplier_product_name', sortable: false },
			{ text: 'Jumlah Retur', value: 'pdor_detail_quantity_sent', align: 'center', sortable: false },
			{ text: 'Jumlah Diterima', value: 'pdor_detail_quantity_received', align: 'center', sortable: false },
			],
			params:[],
		}
	},
	computed: {
		...mapState('pdoReturSupplier', ['listRD', 'RDPagination', 'listStatusRD']),
		...mapState('authSupplier', ['userData']),

		optionStatus() {
			return this.listStatusRD.map( (el) => {
				return {
					code: el,
					status: this.$options.filters.toStatusPDOWH(el)
				}
			})
		}
	},
	methods: {
		...mapActions('pdoReturSupplier', ['getRD', 'getStatusRD', 'getDetailRD', 'exportRD']),
		...mapMutations('pdoReturSupplier', ['clearDataReturDelivery']),
		...mapActions('commonSupplier', ['getLetterHeader']),

		getData() {
			this.getRD().then(() => {
				this.getStatusRD().then(() => {
					this.loading = false
				})
			})
		},
		exportData() {
			this.exportRD(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		countGrandtotal(item, status) {
			let total = 0
			item.forEach( (el) => {
				let price = el.pdor_detail_product_price ? el.pdor_detail_product_price : 0
				let quantity = status == 'created' ? el.pdor_detail_quantity_sent : el.pdor_detail_quantity_approved
				total += price * quantity
			});

			return total
		},
		resetFilter() {
			this.pdor_code.value = ''
			this.pdor_date.value = ''
			this.tanggalRetur = []
			this.pdor_status.value = ''
			this.page = 1
			this.getRD(this.queryString({limit:this.limit, page: this.page}))
		},
		cari() {
			this.params = []
			if (this.pdor_code.value)
				this.params.push(this.pdor_code)
			if (this.pdor_date.value) {
				if (this.pdor_date.value.length > 1) {
					this.pdor_date.value.sort()
					let date = this.pdor_date.value.join('::')
					this.pdor_date.value = date
				}
				this.params.push(this.pdor_date)
			}
			if (this.pdor_status.value)
				this.params.push(this.pdor_status)
			this.page = 1
			this.getRD(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getRD(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getRD(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		getDetail(code) {
			this.getDetailRD(code).then(()=> {
				this.dialog = true
			})
		},
		async printRD(code) {
			await this.getLetterHeader({
				supplier_id: this.userData.user_supplier_supplier_id
			})
			await this.getDetailRD(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Pengiriman Retur`)
		this.getData()
	},
	beforeDestroy() {
		this.clearDataReturDelivery()
	},
	watch: {
		tanggalRetur(val) {
			this.pdor_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getRD(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>